let swRegistration = null;
let permissionGranted = false;

export async function initPushNotifications() {
  if (!('serviceWorker' in navigator) || !('Notification' in window)) {
    console.log('Push notifications not supported');
    return false;
  }
  try {
    swRegistration = await navigator.serviceWorker.register('/sw-notifications.js');
    const permission = await Notification.requestPermission();
    permissionGranted = permission === 'granted';
    // Listen for notification clicks to reload/navigate
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'NOTIFICATION_CLICKED') {
        const url = event.data.url || '/';
        if (window.location.pathname !== url) {
          window.location.href = url;
        } else {
          window.location.reload();
        }
      }
    });
    return permissionGranted;
  } catch (err) {
    console.log('Push notification init failed:', err);
    return false;
  }
}

export function sendPushNotification(title, body, options = {}) {
  if (!permissionGranted || !swRegistration) return;
  const tag = options.tag || 'dining-floor-' + Date.now();
  const url = options.url || '/notifications';
  swRegistration.active?.postMessage({
    type: 'SHOW_NOTIFICATION',
    title,
    body,
    tag,
    url,
  });
}

export function isPushEnabled() {
  return permissionGranted;
}
